<script lang="ts">
import GuestLayout from "@/layouts/GuestLayout.vue"

export default { layout: GuestLayout }
</script>

<script setup lang="ts">
import { Head, router } from "@inertiajs/vue3"
import { ref, useTemplateRef } from "vue"
import { z } from "zod"

import DevToolsButton from "@/components/dev/DevToolsButton.vue"
import DevToolsMailpitButton from "@/components/dev/DevToolsMailpitButton.vue"
import DevToolsPopover from "@/components/dev/DevToolsPopover.vue"
import FlashAlerts from "@/components/FlashAlerts.vue"
import { newSessionPath, passwordsPath } from "@/routes"

const loading = ref(false)
const authFormRef = useTemplateRef("authFormRef")

const schema = z.object({
  email_address: z.string().email("Please enter a valid email address"),
})

function submit() {
  if (!authFormRef.value) return
  loading.value = true
  router.post(passwordsPath(), authFormRef.value.state, {
    onFinish: () => {
      loading.value = false
    },
  })
}

function populateTestEmail() {
  const s = authFormRef.value?.state as z.infer<typeof schema> | undefined
  if (s) {
    s.email_address = "appdev@sevenview.ca"
  }
}
</script>

<template>
  <Head title="Forgot Password" />
  <UAuthForm
    ref="authFormRef"
    title="Forgot your password?"
    description="Enter your email and we'll send you reset instructions."
    :schema="schema"
    :fields="[
      {
        name: 'email_address',
        label: 'Email',
        type: 'email',
        required: true,
        placeholder: 'you@example.com',
        autocomplete: 'username',
      },
    ]"
    :loading="loading"
    :submit="{ label: 'Send Reset Instructions' }"
    @submit="submit"
  >
    <template #validation>
      <FlashAlerts />
    </template>

    <template #footer>
      <UButton :to="newSessionPath()" variant="link" label="Back to sign in" class="text-muted" />
      <DevToolsPopover>
        <DevToolsButton label="Populate test email" @click="populateTestEmail" />
        <DevToolsMailpitButton />
      </DevToolsPopover>
    </template>
  </UAuthForm>
</template>
